/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Deep_LinksInputs */

const en_svchip_deep_links = /** @type {(inputs: Svchip_Deep_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep links`)
};

const ar_svchip_deep_links = /** @type {(inputs: Svchip_Deep_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`روابط عميقة`)
};

const bn_svchip_deep_links = /** @type {(inputs: Svchip_Deep_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডিপ লিংক`)
};

const de_svchip_deep_links = /** @type {(inputs: Svchip_Deep_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep-Links`)
};

const es_svchip_deep_links = /** @type {(inputs: Svchip_Deep_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlaces profundos`)
};

const fr_svchip_deep_links = /** @type {(inputs: Svchip_Deep_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liens profonds`)
};

const pt_svchip_deep_links = /** @type {(inputs: Svchip_Deep_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Links diretos`)
};

const zh_svchip_deep_links = /** @type {(inputs: Svchip_Deep_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`深层链接`)
};

const tr_svchip_deep_links = /** @type {(inputs: Svchip_Deep_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derin bağlantılar`)
};

const ru_svchip_deep_links = /** @type {(inputs: Svchip_Deep_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Глубокие ссылки`)
};

const pl_svchip_deep_links = /** @type {(inputs: Svchip_Deep_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Głębokie linki`)
};

/**
* | output |
* | --- |
* | "Deep links" |
*
* @param {Svchip_Deep_LinksInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_deep_links = /** @type {((inputs?: Svchip_Deep_LinksInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Deep_LinksInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_deep_links(inputs)
	if (locale === "bn") return bn_svchip_deep_links(inputs)
	if (locale === "de") return de_svchip_deep_links(inputs)
	if (locale === "es") return es_svchip_deep_links(inputs)
	if (locale === "fr") return fr_svchip_deep_links(inputs)
	if (locale === "pt") return pt_svchip_deep_links(inputs)
	if (locale === "zh") return zh_svchip_deep_links(inputs)
	if (locale === "tr") return tr_svchip_deep_links(inputs)
	if (locale === "ru") return ru_svchip_deep_links(inputs)
	if (locale === "pl") return pl_svchip_deep_links(inputs)
	return en_svchip_deep_links(inputs)
});